import { render, staticRenderFns } from "./cooperateData.vue?vue&type=template&id=a213ec3e&scoped=true"
import script from "./cooperateData.vue?vue&type=script&lang=js"
export * from "./cooperateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a213ec3e",
  null
  
)

export default component.exports